function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.01333 1.01333L10.0267 0H14.9867L16 1.01333V5.97333L14.9867 6.98667H10.0267L9.01333 5.97333V1.01333ZM10.0267 1.01333V5.97333H14.9867V1.01333H10.0267ZM0 9.97333V4L1.01333 2.98667H6.02667L6.98667 4V9.01333H12L13.0133 9.97333V14.9867L12 16H1.01333L0 14.9867V9.97333ZM6.02667 9.01333V4H1.01333V9.01333H6.02667ZM6.02667 9.97333H1.01333V14.9867H6.02667V9.97333ZM6.98667 14.9867H12V9.97333H6.98667V14.9867Z",
  fill: "#00BDCC"
});

function SvgWidgetsNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgetsNew);
export default __webpack_public_path__ + "static/media/widgets_new.dc6b9073.svg";
export { ForwardRef as ReactComponent };